if (objects.is_page_nos_filiales || objects.is_page_filiale) {
	var slider_company = new Swiper('.slider-company', {
		slidesPerView: 1,
		spaceBetween: 0,
		centeredSlides: true,
		loop: true,
		navigation: {
			nextEl: '#slider-company-tabs .swiper-button-next',
			prevEl: '#slider-company-tabs .swiper-button-prev',
		},
		allowTouchMove: false,
		effect: 'fade',
		fadeEffect: {
			crossFade: true
		}
	});

	var slider_company_gallery = new Swiper('.slider-company-gallery', {
		slidesPerView: 1,
		spaceBetween: 0,
		navigation: {
			nextEl: '.slider-company-gallery .swiper-button-next',
			prevEl: '.slider-company-gallery .swiper-button-prev',
		},
	});

	var slider_company_tabs = new Swiper('.slider-company-tabs', {
		spaceBetween: 30,
		centeredSlides: true,
		loop: true,
		breakpoints: {
			320: {
				slidesPerView: 1,
				spaceBetween: 20
			},
			768: {
				slidesPerView: 3,
				spaceBetween: 30
			},
			1280: {
				slidesPerView: 5,
				spaceBetween: 40
			}
		},
		navigation: {
			nextEl: '#slider-company-tabs .swiper-button-next',
			prevEl: '#slider-company-tabs .swiper-button-prev',
		},
		on: {
			slideChange: function (i) {
				slider_company.slideTo(this.realIndex + 1);
			}
		},
		slideToClickedSlide : true,
	});
}

if (objects.is_page_savoir_faire) {
	var slider_company_gallery = new Swiper('.savoir-faire', {
		slidesPerView: 1,
		spaceBetween: 30,
		breakpoints: {
			320: {
				slidesPerView: 1,
				spaceBetween: 20
			},
			768: {
				slidesPerView: 3,
				spaceBetween: 30
			},
		},
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
	});
}